import React, { useEffect, useState } from 'react';
import { BookCover } from './components/BookCover';
import { BookContent } from './components/BookContent';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
export function App() {
  const [scrollPosition, setScrollPosition] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const position = window.scrollY;
      setScrollPosition(position);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen bg-stone-50 font-serif" data-id="element-0">
      <main className="w-full" data-id="element-1">
        <BookCover data-id="element-2" />
        <BookContent data-id="element-3" />
        <CallToAction data-id="element-4" />
        <Footer data-id="element-5" />
      </main>
    </div>;
}